import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';
import React from 'react';
import { AlgoliaHitTransformer, MiniProductInfoVariant } from '../../../Algolia/transformers/AlgoliaHitTransformer';
import { MiniProductTile } from '../../../MiniProductTile/MiniProductTile';

export const MiniProductComponent = ({
  hit,
  position,
  miniProductInfoVariant = 'None',
  shouldShowNumber = false,
  trackingDescriptor: _trackingDescriptor,
}: {
  hit: AlgoliaProductHit;
  position?: number;
  miniProductInfoVariant?: MiniProductInfoVariant;
  shouldShowNumber?: boolean;
  trackingDescriptor?: any;
}) => (
  <MiniProductTile
    {...AlgoliaHitTransformer.toMiniProductTileProps(hit, {
      infoVariant: miniProductInfoVariant,
      number: shouldShowNumber ? position : undefined,
    })}
    shouldUseProgressiveImage
  />
);
